/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {divideBySpaces} from 'helpers/numberHelpers';

import {LastCheckType} from '../types';
import {mapSensorGroupCollection} from './mapSensorGroupCollection';
import {getSubRows} from './getSubRows';
import {getPerCampaignFound} from './getPerCampaignFound';

/**
 * Сосчитает все срабатывания сенсоров в этой строке и добавит подстроки.
 * @param checks
 * @param campaignId
 */

const mapSensorCount = (
  checks: ReadonlyArray<LastCheckType>,
  campaignId?: string,
): TanStackTableData => {
  const getFound = (check: LastCheckType) =>
    campaignId ? getPerCampaignFound(check, campaignId) : check.found;

  const count = checks.reduce((acc, cur) => {
    return acc + getFound(cur);
  }, 0);

  const collection = mapSensorGroupCollection(checks, campaignId);
  const subRows = getSubRows([
    {
      collection,
      columnKey: 'sensors',
    },
  ]);

  const result: TanStackTableData = {
    sensors: divideBySpaces(count),
  };

  if (subRows.length) {
    result.subRows = subRows;
  }

  return result;
};

export {mapSensorCount};
